import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Auth from '@/views/Auth'
import Journal from '@/views/Journal'
import Presence from '@/views/Presence'
import Page404 from '@/views/Page404'
import navigator from './middleware/navigator'
import Tresult from '@/views/Tresult'
import Disciplines from '@/views/Disciplines'
import ViewingDiscipline from '@/views/ViewingDiscipline'
import Messages from '@/views/Messages'
import ViewingGroup from '@/views/ViewingGroup'
import Statement from '@/views/Statement'
import JournalNew from '@/views/JournalNew'
import TresultView from '@/views/TresultView'
import Test from '@/views/Test'
import Schedule from '@/views/Schedule';
import Tgrade from '@/views/Tgrade'
import Docs from '@/views/Docs'
import middlewarePipeline from './middlewarePipeline'
import store from '../store'

Vue.use(VueRouter)
const routes = [

  {
    path:'/404',
    component: Page404,
    meta: {
      nav: false,
      fullScreen: true,
    },
    beforeEnter: (to, from, next) => {
      if(store.getters.getAuthenticated){
        return next()
      }else{
        return next('/auth')
      }
    }
  },
  {
    path: '/home', //указываем путь для роута
    name: 'home', //указываем имя роута
    component: Home, //указываем компонент который будет задействован при роуте
    meta: {
      title:"Главная страница", //title роута,  на случай если нужен будет popap
      icon:"chalk-board", //иконка для отображения в панели навигации
      nav:true, // если нужно отобразить этот роут в навигационном меню, ставим флаг true
      fullScreen: false, //Если эта страница должна быть развёрнута на весь экран, ставим флаг true
      middleware: [
          navigator //Мидла которая дает доступ на этот роут только авторизованным пользователям, если надо предоставить общий доступ, оставь массив пустым
      ]
    },
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta:{
      title:"Страница авторизации",
      icon:"fas fa-sign-in-alt",
      nav:false,
      fullScreen: true
    }
  },
  {
    path: '/journal',
    name: 'Journal',
    component: Journal,
    meta:{
      title:"Календарь",
      nav: true,
      icon: "calendar",
      fullScreen: false,
      middleware: [
        navigator
      ]
    }
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule,
    meta:{
      title:"Расписание",
      nav: true,
      icon: "users",
      fullScreen: false,
      middleware: [
        navigator
      ]
    }
  },
  {
     path: '/journal-new',
     name: 'Journal_new',
     component: JournalNew,
     meta:{
       title: 'Журнал',
       nav: true,
       icon: 'bookOpen',
       fullScreen: false,
       middleware: [
         navigator
       ]
     }
   },
  {
    path: '/journal/presence/:sid',
    name: 'presence',
    component: Presence,
    meta:{
      nav:false,
      fullScreen: false,
      middleware: [
        navigator
      ]
    }
  },
  {
    path: '/tresult',
    name: 'tresult',
    component: Tresult,
    meta: {
      title:"Работы студентов",
      icon:"poll",
      nav:true,
      fullScreen: false,
      middleware: [
          navigator
      ]
    },
  },

  {
    // сопоставляется со всем
    path: '*',
    redirect: '/404',
    meta: {
      nav: false,
      fullScreen: false,
    }
  },
  {
    path:'/',
    redirect: '/home',
    meta: {
      nav: false,
      fullScreen: false,
    }
  },
  {
    path: '/disciplines',
    name: 'Disciplines',
    component: Disciplines,
    meta: {
      title:"Дисциплины",
      icon:"book",
      nav:true,
      fullScreen: false,
      middleware: [
          navigator
      ]
    },
  },
  {
    path: '/disciplines/viewing-disciplines/:did',
    name: 'viewingDisciplines',
    component: ViewingDiscipline,
    meta: {
      nav:false,
      fullScreen: false,
      middleware: [
          navigator
      ]
    },
  },
  {
    path: '/messages',
    name: 'Messages',
    component: Messages,
    meta: {
      title:"Сообщения",
      icon:"envelop",
      nav:true,
      fullScreen: false,
      middleware: [
          navigator
      ]
    },
  },
  {
    path: '/disciplines/viewing-groups/:did',
    name: 'ViewingGroup',
    component: ViewingGroup,
    meta:{
      title: 'Группы',
      nav: false,
      fullScreen: false,
      middleware: [
        navigator
      ]
    }
  },
  {
    path: '/tresult/view/:did',
    name: 'TresultView',
    component: TresultView,
    meta: {
      nav:false,
      fullScreen: false,
      middleware: [
          navigator
      ]
    },
  },
  {
    path: '/statement',
    component: Statement,
    name: 'Statement',
    meta:{
      nav:true,
      icon: "coins",
      title: "Табель",
      fullScreen: false,
      middleware: [
          navigator
      ]
    }
  },
  {
    path: '/docs',
    component: Docs,
    name: 'Docs',
    meta:{
      nav: true,
      icon: "fileLines",
      title: "Инструкции и регламенты",
      fullScreen: false,
      middleware: [
          navigator
      ]
    }
  },
  // {
  //   path: '/tgrade',
  //   component: Tgrade,
  //   name: 'Tgrade',
  //   meta:{
  //     nav: true,
  //     icon: "graduation-cap",
  //     title: "Ведомость",
  //     fullScreen: false,
  //     middleware: [
  //         navigator
  //     ]
  //   }
  // },
  // {
  //   path: '/test',
  //   name: 'Test',
  //   component: Test,
  //   meta: {
  //     nav: false,
  //     fullScreen: false,
  //     middleware: [
  //         navigator
  //     ]
  //   }
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

//Хук который срабатывает перед переходом, на новый роут здесь запускаются middleware прописанные в роутах, подробнее https://router.vuejs.org/ru/guide/advanced/navigation-guards.html#гnобаnьные-хуки-разрешения-перехода
router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
      return next()
  }
  const middleware = to.meta.middleware

  const context = {
      to,
      from,
      next,
      store
  }
  return middleware[0]({
      ...context,
      next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
